import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAuthStore = defineStore('auth', () => {
    const sessionState = ref('active')

    const isExpired = computed(() => sessionState.value === 'expired')
    const isRefreshing = computed(() => sessionState.value === 'refreshing')

    const setExpired = () => {
        sessionState.value = 'expired'
        // Drop any pending OAuth redirect — if the session expired mid-flow,
        // the user is going back through login anyway and the saved destination
        // may belong to a different identity by the time they return.
        try {
            sessionStorage.removeItem('auth_redirect')
        } catch {
            // sessionStorage unavailable
        }
    }
    const setRefreshing = () => { sessionState.value = 'refreshing' }
    const setActive = () => { sessionState.value = 'active' }

    return {
        sessionState,
        isExpired,
        isRefreshing,
        setExpired,
        setRefreshing,
        setActive
    }
})
